import React, { useEffect, useState } from 'react';
import {
  Box,
  makeStyles,
  Paper,
  Typography,
  Grid,
  Divider,
  ButtonBase,
  Button,
  LinearProgress,
} from '@material-ui/core';
import { BsFillPersonFill } from 'react-icons/bs';
import { AiOutlineCamera, AiOutlineEdit } from 'react-icons/ai';
import {
  getProfileImageData,
  saveStudentProfileImage,
  saveStudentProfileInfo,
} from '../../../../Utils/apiServices';
import './profile.css';
import imagePic from '../../../../Assets/Ken42logo.png';
// import manipallogo from '../../../../Assets/manipal-logo.svg';
import PersonalDetails from '../../../../Utils/profile/personalDetails';
import KenSnackBar from '../../../../Components/KenSnackbar';
import KenLoader from '../../../../Components/KenLoader';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  parentRoot: {
    borderRadius: '3px',
    margin: '32px 0px 32px 0px',
    position: 'relative',
    padding: '15px 25px 30px',
  },
  parentsRoot: {
    borderRadius: '3px',
    margin: '32px 0px 32px 0px',
    position: 'relative',
    // padding: '15px 25px 30px'
  },
  circle: {
    width: '100px',
    height: '100px',
    lineHeight: '100px',
    borderRadius: '50%',
    color: theme.palette.KenColors.shadowColor,
    textAlign: 'center',
    background: `${theme.palette.KenColors.neutral100}`,
    fontSize: 'xxx-large',
  },
  profile: {
    position: 'absolute',
    top: '32px',
    left: '0px',
    right: '0px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  studentName: {
    fontWeight: 600,
    fontSize: '16px',
    color: theme.palette.KenColors.neutral900,
    marginTop: '8px',
  },
  rectangle: {
    height: '50px',
    background: 'linear-gradient(96.64deg, #B3D4FF 3.24%, #FED9D7 95.61%)',
    marginLeft: 10,
  },
  profileContainer: {
    position: 'relative',
  },
  heading: {
    padding: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.KenColors.neutral100,
  },
  divInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  img: {
    padding: '0px 16px 16px 16px',
  },
  info: {
    marginBottom: 10,
    fontSize: '12px',
    color: `${theme.palette.KenColors.primary}`,
  },
  divider: {
    margin: '0px 0px 10px 0px',
  },
  menuItemDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.KenColors.neutral40,
    },
  },
  av: {
    width: '36px',
    height: '36px',
    lineHeight: '33px',
    borderRadius: '55%',
    fontSize: 20,
    color: '#fff',
    textAlign: 'center',
    background: `${theme.palette.KenColors.neutral100}`,
  },
  titleDetails: {
    color: `${theme.palette.KenColors.neutral400}`,
    fontSize: 10,
  },
  plainLink: {
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
      margin: '30px',
    },
    parentRoot: {
      borderRadius: '3px',
      margin: '32px 0px 32px 0px',
      position: 'relative',
      backgroundColor: '#F4F6FC',
      // height: '100%',
      // marginTop: 0,
    },
  },
  activeMenuItem: {
    borderLeft: `3px solid ${theme.palette.KenColors.cardActiveBorderColor}`,
    borderRadius: 4,
    backgroundColor: theme.palette.KenColors.cardActiveBackground,
    '& $titleName': {
      color: theme.palette.KenColors.cardActiveColor,
    },
  },
  root: {
    padding: 10,
    marginBottom: 9,
  },
  timerBox: {
    background: theme.palette.KenColors.tertiaryGreen49,
    padding: 5,
    borderRadius: 3,
    width: 105,
  },
  timerText: {
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.KenColors.tertiaryGreen,
  },
  progressBarBox: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: '#E5E5E5',
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#27AE60',
    },
  },
  progressBar: {
    height: 8,
    borderRadius: 27,
  },
  colorPrimary: {
    backgroundColor: theme.palette.KenColors.neutral20,
  },
  barColorPrimary: {
    backgroundColor: theme.palette.KenColors.tertiaryGreen49,
  },
}));
const ProfileDetails = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { currentProfile, state, setState } = props;
  console.log('props', props);
  const [data, setData] = useState(props?.state);
  const [image, setImage] = useState();
  const [profileUpdateAcc, setProfileUpdateAcc] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [loader, setLoader] = useState(false);
  const classes = useStyles();
  function handleChangeInput(evt) {
    const value = evt.target.value;
    setData({
      ...data,
      [evt.target.name]: value,
    });
  }

  console.log('statestatestatestate', data);
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const handleProfileSave = () => {
    setLoader(true);
    console.log('data==============>', data);
    const newData = { ...data, ContactId: data?.contactId };
    saveStudentProfileInfo(newData)
      .then((data) => {
        console.log('handleProfileSave', data);
        handleSnackbarOpen('success', 'successfully save');
        setProfileUpdateAcc(false);
        setLoader(false);
      })
      .catch((err) => {
        handleSnackbarOpen('error', err.message);
        setProfileUpdateAcc(true);
        setLoader(false);
      });
    // setProfileUpdateAcc(false);
  };
  const getProfileImage = async () => {
    const ContactId = data?.contactId;
    const res = await getProfileImageData(ContactId);
    console.log('getProfileImageData', res);
    setImage(res.files[res.files.length - 1]?.body);
  };

  const updateProfileImage = async (data) => {
    const ContactId = data?.contactId;
    const imageData = await saveStudentProfileImage(data, ContactId);
    console.log('imageData', imageData);
    const datasss = await getProfileImage(ContactId);
    console.log('data', datasss);
    setLoading(false);
  };

  useEffect(() => {
    const ContactId = location?.state?.contactId;
    getProfileImage(ContactId);
    // setLoading(true)
  }, [state, image]);
  console.log('loader', loading);
  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      console.log('img---------------------->', reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const progressStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    color: '#27AE60',
  };
  const handleImage = (e) => {
    setLoading(true);
    let formData = new FormData();
    formData.append('signature', e.target.files[0]);
    updateProfileImage(formData);
  };
  const onCancelHandle = () => {
    setProfileUpdateAcc(false);
  };
  return (
    <>
      {' '}
      {loader && <KenLoader />}
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={5000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      <Paper
        className={classes.parentsRoot}
        style={{ padding: '20px 25px', backgroundColor: '#fff' }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={11}>
            <h2>Basic Information</h2>
          </Grid>

          {profileUpdateAcc ? (
            <Grid item xs={11} sm={2}>
              <Paper
                className={classes.parentsRoot}
                style={{
                  height: '100%',
                  marginTop: 0,
                  paddingBottom: '35px',
                  marginBottom: 0,
                  // padding: '20px 25px',
                }}
              >
                {/* <BsFillPersonFill size={260} color="#D7DEE9" /> */}
                {loading && <KenLoader />}
                {image ? (
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={`data:image/png;base64,${image}`}
                    className="add_grp_image"
                  />
                ) : (
                  // <BsFillPersonFill
                  //   style={{
                  //     height: '100%',
                  //     width: '100%',
                  //     border: '1px solid #CCD1D8',
                  //   }}
                  //   color="#D7DEE9"
                  // />
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={imagePic}
                    className="add_grp_image"
                  />
                )}
                <input
                  style={{
                    paddingTop: '10px',
                    paddingLeft: '2px',
                  }}
                  type="file"
                  // accept="image/*"
                  name="image"
                  id="file"
                  onChange={(e) => handleImage(e)}
                  // style="display: none;"
                />
              </Paper>
            </Grid>
          ) : (
            <>
              {currentProfile && (
                <Grid item xs={12} sm={1} className="editButton">
                  <AiOutlineEdit
                    size={23}
                    onClick={() => setProfileUpdateAcc(true)}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={2}>
                {/* <Paper variant="outlined"> */}
                {console.log('image', image)}
                {image ? (
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={`data:image/png;base64,${image}`}
                    className="add_grp_image"
                  />
                ) : (
                  // <BsFillPersonFill
                  //   style={{
                  //     height: '100%',
                  //     width: '100%',
                  //     border: '1px solid #CCD1D8',
                  //   }}
                  //   color="#D7DEE9"
                  // />
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={imagePic}
                    className="add_grp_image"
                  />
                )}

                {/* </Paper> */}
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={10}>
            {data && (
              <PersonalDetails
                state={data}
                personalDetails={profileUpdateAcc}
                setpersonalDetails={setProfileUpdateAcc}
                onChange={(e) => {
                  handleChangeInput(e);
                }}
                onSubmit={handleProfileSave}
                onCancel={onCancelHandle}
              />
            )}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default ProfileDetails;
